// The band, identity and contact rules are the Customer Detail header's own (same Figma chrome,
// 1923:862322 vs 603-205804), imported rather than copied. Only the dealer-specific delta lives here.

// Plain text, bottom-aligned with the contacts row; there is no overflow menu above it.
.orderCount {
  align-self: flex-end;
}
